"use client";

import type { DisplayType } from "../../../lib/types/enums/displayTypeEnum";
import { sectionSchema } from "../../../lib/types/schema/home/sectionSchema";
import type { UseRequestQueryProps } from "../../../request/hooks/useRequestQuery";
import { useRequestQuery } from "../../../request/hooks/useRequestQuery";
import { keyFavorites } from "./keyFavorites";

export type UseRequestFavoritesProps = UseRequestQueryProps & {
  displayType: DisplayType;
};

export const useRequestFavorites = ({
  displayType,
  ...props
}: UseRequestFavoritesProps) => ({
  query: useRequestQuery<typeof sectionSchema>({
    queryFnRequestProps: {
      schema: sectionSchema,
      urlBackendPath: `/me/favorites${displayType === "sessions" ? "?format=prayer" : ""}`,
    },
    queryKey: keyFavorites({ displayType }),
    ...props,
  }),
});
